<template>
  <div>
    <v-select
      v-model="selectedMenu"
      item-text="label"
      item-value="value"
      :items="menus"
      @change="changeSelectMenu"
      solo
      return-object
      class="select-menu"
    />
  </div>
</template>

<script>
export default {
  props: {
    menus: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedMenu: {}
    }
  },
  methods: {
    initSelectMenu() {
      console.log("セレクトメニューを初期化します。");
      // 初期値はmenusの先頭にする
      if (this.menus.length > 0) {
        console.log('先頭の' + JSON.stringify(this.menus[0]) + 'を選択されているメニューにします。');
        this.selectedMenu = this.menus[0];
      }
      this.$emit('init-select-menu', this.selectedMenu);
    },
    /**
     * セレクトメニューが変更された場合に呼ばれる。
     * 親に選択されたメニューを送る。
     */
    changeSelectMenu() {
      this.$emit('change-select-menu', this.selectedMenu);
    }
  },
  created() {
    this.initSelectMenu();
  }
};
</script>

<style scoped>
@media screen and (max-width: 480px) {
  .select-menu {
    font-size: 90%;
  }
}
</style>